import { axiosApi, phpAxiosApi } from './requests/BaseRequest'
import { Data } from '@/stores/data'
import { ElementTip } from '@/stores/ElementTip'
export class HTTP {
  /**
   *  post 获取二维码
   * @returns
   */
  static getQrCode() {
    return axiosApi.request({
      url: '/userinfo/getLoginQrCode',
      method: 'get'
    })
  }

  /**
   *  post 二维码微信登录，获取用户信息和token
   * @returns
   */
  static wxLoginStatus(key: string) {
    return axiosApi.request({
      url: '/userinfo/loginStatus',
      method: 'GET',
      params: {
        key
      }
    })
  }
 /**
   * post 获取word地址
   * @param wordText 需要专成word的文字
   * @returns
   */
 static getWordUrl(wordText: string) {
  // return new Promise((resolve, reject) => {
  //   resolve({url:'ces'})
  // })
  return axiosApi.request({
      url: '/myFile/markdownDownloadWord',
      data: {
        content: wordText
      },
  });
}
  /**
   *  get 获取所有图书
   * @returns
   */
  static getBook() {
    return axiosApi.request({
      url: '/userinfo/getBook',
      method: 'GET'
    })
  }
   /**
   *  get 提交书码
   * @returns
   */
   static activationCode(data:any) {
    return axiosApi.request({
      url: '/userinfo/activationCode',
      method: 'GET',
      params: {
        ...data
      }
    })
  }
     /**
   *  get 修改书码绑定的书
   * @returns
   */
     static updateActivationCode(data:any) {
      return axiosApi.request({
        url: '/userinfo/updateActivationCode',
        method: 'GET',
        params: {
          ...data
        }
      })
    }
  


  /**
   *  get 获取学段学科
   * @returns
   */
  static getSubject() {
    return axiosApi.request({
      url: '/dict/getSubject',
      method: 'GET'
    })
  }

  /**
   *  get 获取版本
   * @returns
   */
  static getEdition(gradeId: number | string) {
    return axiosApi.request({
      url: '/dict/getEdition/' + gradeId,
      method: 'get'
    })
  }

  /**
   *  get 获取年级
   * @returns
   */
  static getGrade(subjectId: number | string) {
    return axiosApi.request({
      url: '/dict/getGrade/' + subjectId,
      method: 'get'
    })
  }
  /**
   * 导出ppt
   */
static pptUploadFile(formData:any){
  return axiosApi.request({
    url: '/myFile/uploadFile',
    method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: formData,
  })
}


  /**
   * post 获取册别
   * @param editionId 教材版本id
   * @param gradeId  年级id
   * @returns
   */
  static getVolume(editionId: string) {
    return axiosApi.request({
      url: '/dict/getVolume/' + editionId,
      method: 'GET'
    })
  }

  /**
   *  get 获取教案结构
   * @returns
   */
  static getStructure(resourceType: string) {
    return axiosApi.request({
      url: '/dict/get/structure',
      method: 'GET',
      params: {
        resourceType
      }
    })
  }

  /**
   *  post 获取sessionId
   * @returns
   */
  static getSessionId() {
    return axiosApi.request({
      url: '/myFile/getId',
      method: 'GET'
    })
  }

  /**
   *  post 上传文件列表
   * @returns
   */
  static pdfUpload(formData: any, onUploadProgress: any) {
    return axiosApi.request({
      url: '/myFile/analysis',
      timeout: 10 * 60 * 1000,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: {
        ...formData
      },
      onUploadProgress
    })
  }
  static uploadImage(file: File) {
    const maxSize = 5 * 1024 * 1024
    console.log('>file.size>>', file.size)
    if (file.size > maxSize) {
      ElementTip.warningTip('文件过大')
      return Promise.reject('文件过大')
    }
    const formData = new FormData()
    formData.append('dataKey', '0')
    formData.append('bizType', 'common')
    formData.append('file', file)
    return axiosApi.request({
      url: '/myFile/uploadImage',
      timeout: 30 * 1000,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: formData
    })
  }
  /**
   *  post 获取ppt  json
   * @returns
   */
  static pptGeneration(content: string) {
    return axiosApi.request({
      url: '/ai/document/pptGeneration',
      method: 'post',
      timeout: 0,
      data: {
        content
      }
    })
  }

  /**
   *  post 生成教案
   * @returns
   */
  static generationLessonPlan(data: any) {
    return axiosApi.request({
      url: '/ai/document/generation',
      method: 'post',
      data: {
        ...data
      }
    })
  }

  //获取问答的回答
  static getAIAnswer(data: any) {
    return axiosApi.request({
      url: '/ai/question',
      data: {
        ...data
      }
    })
  }

  //获取卡片默认信息
  static getCardData(data: any) {
    return axiosApi.request({
      url: '/ai/card',
      data: {
        ...data
      }
    })
  }
  //获取视频列表
  static videoList(bookId: string) {
    return axiosApi.request({
      url: '/video/videoList',
       method: 'GET',
      params: {
        bookId
      }
    })
  }
  //教案/课件等获取历史记录
  static getHistoryData(sessionId: string, fixedTimestamp: string) {
    return axiosApi.request({
      url: '/myFile/getHistory/' + sessionId + '/' + fixedTimestamp,
      method: 'get'
    })
  }
static cscs(data:any){
  return axiosApi.request({
    url: '/newapipc/emb/newapipc.php',
    headers: {
      'Connection': 'keep-alive', 
      'Content-Type': 'multipart/form-data'
    },
   
    data: {
        ...data
      }
  })
}
  //获取教案信息
  static getBookOne(data: any) {
    return axiosApi.request({
      url: '/t-book/one',
      data: {
        ...data
      }
    })
  }
static uploadFiles (wjId:string,data:any,wjGroup:string,wjName:string){
  console.log(">>data>>",data)
  return axiosApi.request({
    url: 'dufile/fileServer/uploadFiles.php',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: {
      openid: Data.userInfo.value.openid,
      wjId: wjId,
      wjGroup:wjGroup,
      file:data,
      wjName:wjName,
    }
  })
}
//获取上传文件的数据
static getUploadData(wjId: string,cancelHandler:any) {
  return axiosApi.request({
      url: 'dufile/fileServer/getFileInfo.php',
      method: 'GET',
      timeout: 10*60*1000,
      params: {
           openid: Data.userInfo.value.openid,
          wjId:wjId
      },
      ...cancelHandler
   });
}

  //获取图片
  static wenToImage(content: string) {
    return axiosApi.request({
      url: '/myFile/wenToImage',
      id: '/myFile/wenToImage',
      data: {
        content
      }
    })
  }

  /**
   * 保存
   * @param data
   * @returns
   */
  static addFile(data: any) {
    return axiosApi.request({
      url: '/myFile/add',
      data: {
        ...data
      }
    })
  }
  /**
   * 导出
   * @param data
   * @returns
   */
  static downloadFile(data: any,resourceType:string) {
    let url='/myFile/downloadFile';
    if(resourceType=='questions'){
      url='/myFile/downloadQuestionWord';
    }
    return axiosApi.request({
      url: url,
      timeout:60*1000,
      data: {
        ...data
      }
    })
  }

  //获取知识库文件列表
  static getWorkList(data: any) {
    return axiosApi.request({
      url: '/myFile/page',
      data: {
        ...data
      }
    })
  }

  //删除单个文件
  static deleteWorkItem(id: string) {
    return axiosApi.request({
      url: '/myFile/del/' + id,
      method: 'get'
    })
  }
  static getFileById(id: string) {
    return axiosApi.request({
      url: '/myFile/by/' + id,
      method: 'get'
    })
  }

  /**
   *  get 获取用户信息
   * @returns
   */
  static getUserInfo() {
    return axiosApi.request({
      url: '/userinfo/getUserInfo',
      method: 'get'
    })
  }

  /**
   *  get 获取生成设置 名称
   * @returns
   */
  static getSearchData(phaseId: string, subjectId: string, content: string, resourceType: string) {
    return axiosApi.request({
      url: '/ai/search',
      method: 'get',
      params: {
        phaseId,
        subjectId,
        content,
        resourceType
      }
    })
  }

  /**
   *  get 获取图形验证码
   * @returns
   */
  static getLoginQrCodeStrBase64() {
    return axiosApi.request({
      url: '/userinfo/getLoginQrCodeStrBase64',
      method: 'get'
    })
  }

  /**
   *  get 获取短信验证码
   * @returns
   */
  static getLoginQrCodeSMS(data: any) {
    return axiosApi.request({
      url: '/userinfo/getLoginQrCodeSMS',
      method: 'post',
      data: {
        ...data
      }
    })
  }

  /**
   *  post 提交申请表单
   * @returns
   */
  static submitMembership(data: any) {
    return axiosApi.request({
      url: '/userinfo/submitMembership',
      method: 'post',
      data: {
        ...data
      }
    })
  }

  /**
   *  get 获取微信群二维码 个人客服
   * @returns
   */
  static getWXQrCode() {
    return axiosApi.request({
      url: '/userinfo/getQrCode',
      method: 'get'
    })
  }

  /**
   *  get 领取会员资格
   * @returns
   */
  static confirmationMembership() {
    return axiosApi.request({
      url: '/userinfo/confirmationMembership',
      method: 'get'
    })
  }

  /**
   *  post 提交申请表单
   * @returns
   */
  static submitFeedback(data: any) {
    return axiosApi.request({
      url: '/problem-feedback/add',
      method: 'post',
      data: {
        ...data
      }
    })
  }

  /**
   *  post 活动是否开启
   * @returns
   */
  static activityInfo() {
    return axiosApi.request({
      url: '/activity/activityInfo',
      method: 'GET',
    })
  }

  /**
   *  post 获取邀请结果列表
   * @returns
   */
  static getRelationshipBindingResult() {
    return axiosApi.request({
      url: '/userinfo/relationshipBindingResult',
      method: 'GET'
    })
  }

  /**
   *  post 绑定关系
   * @returns
   */
  static getRelationshipBinding(openId: string) {
    return axiosApi.request({
      url: '/userinfo/relationshipBinding',
      method: 'GET',
      params: {
        openId
      }
    })
  }

  /**
   *  post 获取中奖名单
   * @returns
   */
  static getWinningList() {
    return axiosApi.request({
      url: '/userinfo/winningList',
      method: 'GET'
    })
  }

  //获取历史记录列表
  static getHistoryList() {
    return axiosApi.request({
      url: '/ai/conversation/list',
      method: 'get'
    })
  }

  //获取小鸿问答页工作事务内容
  static getWorkAffairsList() {
    return axiosApi.request({
      url: '/myFile/getWorkAffairsList',
      method: 'get'
    })
  }

  //删除单个/多个历史记录
  static deleteHistoryItem(timeStamp: any) {
    return axiosApi.request({
      url: '/ai/del/conversation',
      method: 'post',
      data: timeStamp
    })
  }

  //1031活动信息接口
  static getActInitData(data: any) {
    return phpAxiosApi.request({
      url: '/api/activity/newYearDay/index.php',
      method: 'post',
      data: {
        openid: data.openid,
        inviter: data.inviter
      }
    })
  }

  //1031活动 查询奖品剩余数量
  static checkSyNum(key: string) {
    return phpAxiosApi.request({
      url: '/api/activity/newYearDay/checkSyNum.php',
      method: 'post',
      data: {
        prize: key,
        openid: Data.userInfo.value?.openid
      }
    })
  }

  /**
   *  post 获取手机号验证码
   * @returns
   */
  static getSMS(tel: string) {
    return phpAxiosApi.request({
      url: '/api/sms.php',
      method: 'POST',
      params: {
        tel
      }
    })
  }

  /**
   *  post 获取手机号验证码
   * @returns
   */
  static getVerify(tel: string, code: string) {
    return phpAxiosApi.request({
      url: '/api/verify.php',
      method: 'POST',
      data: {
        tel: tel,
        code: code
      }
    })
  }

  /**
   *  post 获取手机号验证码
   * @returns
   */
  static getCollect(form: any) {
    return phpAxiosApi.request({
      url: '/api/activity/newYearDay/collect.php',
      method: 'POST',
      data: {
        ...form
      }
    })
  }

  //获取会员商品列表
  static getMembershipContent() {
    return axiosApi.request({
      url: '/member/getMembershipContent',
      method: 'get'
    })
  }

  //获取支付二维码
  static getNativePayQrCode(id: string, payType: string) {
    return axiosApi.request({
      url: '/member/getNativePayQrCode/' + id + '/' + payType,
      method: 'get'
    })
  }

  //获取订单列表
  static getOrderList() {
    return axiosApi.request({
      url: '/member/getOrderList',
      method: 'get'
    })
  }

  //获取订单支付情况
  static getOrderPayStatus(id: string) {
    return axiosApi.request({
      url: '/member/getOrderPayStatus/' + id,
      method: 'get'
    })
  }

  //获取购买会员人员
  static getCarouselContent() {
    return axiosApi.request({
      url: '/member/getCarouselContent',
      method: 'get'
    })
  }

  /**
   *  get 获取版本
   * @returns
   */
  static getVersionList(phaseId: string, subjectId: string) {
    return axiosApi.request({
      url: '/dict/getVersionList',
      method: 'GET',
      params: {
        phaseId,
        subjectId
      }
    })
  }

  /**
   *  get 获取教案
   * @returns
   */
  static getTikuList(phaseId: string, subjectId: string, versionId: string) {
    return axiosApi.request({
      url: '/dict/getTikuList',
      method: 'GET',
      params: {
        phaseId,
        subjectId,
        versionId
      }
    })
  }

  /**
   *  get 获取章节
   * @returns
   */
  static getTikuChapter(bookId: string) {
    return axiosApi.request({
      url: '/dict/getTikuChapter',
      method: 'GET',
      params: {
        bookId
      }
    })
  }

  /**
   *  get 获取知识点
   * @returns
   */
  static getTikuKeyPoint(phaseId: string, subjectId: string) {
    return axiosApi.request({
      url: '/dict/getTikuKeyPoint',
      method: 'GET',
      params: {
        phaseId,
        subjectId
      }
    })
  }

  /**
   *  get 获取图书下的章节目录
   * @returns
   */
  static getBookChapter(bookId: any) {
    return axiosApi.request({
      url: '/userinfo/getBook/'+ bookId,
      method: 'GET'
    })
  }
}
